const updateCategories = (data, ctx) => {
    if (data === null || data === undefined)
        return;
    const initialData = JSON.parse(ctx.data).sort((a, b) => (a.Title > b.Title) ? -1 : 1);
    ctx.categories = initialData.map((c) => 
    // eslint-disable-next-line no-param-reassign
    c);
};

export { updateCategories };
